export enum Design {
  OLD = 'old',
  NEW = 'new',
}
